// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__tAqrr","inputWrap":"Table_inputWrap__3hA4a","col":"Table_col__2EF6D","bmiTooltip":"Table_bmiTooltip__1PORN"};